import { render, staticRenderFns } from "./AcceptDialog.vue?vue&type=template&id=60173122&scoped=true&"
import script from "./AcceptDialog.vue?vue&type=script&lang=js&"
export * from "./AcceptDialog.vue?vue&type=script&lang=js&"
import style0 from "./AcceptDialog.vue?vue&type=style&index=0&id=60173122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60173122",
  null
  
)

export default component.exports